<section class="sh-dialog__content">
    <sh-form-radio-list
        [id]="'record-type-select'"
        [label]="'creation-flow.record-type-dialog.message' | translate"
        [control]="recordTypeControl"
        [items]="recordTypeOptions"
        [errorResponse]="ErrorResponse.TOUCHED"
    ></sh-form-radio-list>
    @if ($showFacialRecognitionConsent()) {
        <sh-form-toggle-switch
            [id]="'facial-recognition-consent'"
            [control]="facialRecognitionConsentControl"
            [label]="'facial-recognition.consent.label' | translate"
            [description]="'facial-recognition.consent.description' | translate"
        ></sh-form-toggle-switch>
    }
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="submit()" [disabled]="!recordTypeFormGroup.valid">{{ config.data.yes }}</button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.no }}</button>
    </div>
    <div class="sh-action-group -sh-align-end"></div>
</footer>
